import { Component, OnInit } from '@angular/core';
import { VacationService } from '../../../../services/vacation.service';
import { SubscriptionService } from '../../../../services/subscription.service';
import { ModalService } from '../../../../services/modals.service';
import { GoogleAnalyticsService } from '../../../../services/google-analytics.service';
import { openModal, closeModal, closeModalWithoutRemovingBackdrop } from '../../../../shared/modal-functions';
import { responseIsSuccess } from '../../../../shared/helper-functions';
import { arrayIsDefinedAndContainsKey } from '../../../../shared/array-functions';
import { subscriptionViewSpanish, vacationView } from '../../subscription.static.data';

@Component({
  selector: 'app-vacation-list',
  templateUrl: './vacation-list.component.html',
  styleUrls: ['../../../../app.component.css']
})
export class VacationListComponent implements OnInit {
  // Static Data
  subscriptionView: any;
  vacationView: any;
  // Control view  
  openModal: any;
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  // Response data
  responseTitle: string;
  responseBody: string;
  responseAction: string;
  // User data
  selectedVacationToCancel: object;

  constructor(public vacationService: VacationService, private subscriptionService: SubscriptionService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService) {
    this.subscriptionView = subscriptionViewSpanish;
    this.vacationView = vacationView;
    this.openModal = openModal;
    this.closeModal = closeModal;
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
  }

  ngOnInit() {
  }

  cancelVacation() {
    this.vacationService.cancelVacation(this.selectedVacationToCancel['SubEventID']).subscribe(
      (response) => {
        this.closeModalWithoutRemovingBackdrop('#cancelVacationModal');
        if(responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CancelVacation') && response['CancelVacation']) {
          this.openModal('#responseSubscriptionModal');
          this.responseTitle = vacationView.successCancelVacation.title;
          this.responseBody = vacationView.successCancelVacation.body;
          this.responseAction = vacationView.successCancelVacation.action;
          this.vacationService.getVacationList(this.subscriptionService.selectedSubscriptionId);
          this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmando_Vacaciones_Canceladas');
        } else {
          this.openModal('#responseSubscriptionModal');
          this.responseTitle = vacationView.errorCancelVacation.title;
          this.responseBody = vacationView.errorCancelVacation.body;
          this.responseAction = vacationView.errorCancelVacation.action;
          this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Error_Cancelar_Vacaciones');
        }
    });
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/schedule-vacation/vacation-list/vacation-list.component.ts